// ============================================
// Accordion Module
// Handles Index TOC toggle and FAQ accordion
// ============================================

/**
 * Initialize Index (TOC) toggle functionality
 * Toggles the visibility of the index list
 */
export function initIndexToggle() {
  const indexes = document.querySelectorAll('.js-index');

  indexes.forEach((index) => {
    const toggle = index.querySelector('.js-index-toggle');
    const list = index.querySelector('.c-index__list');

    if (toggle && list) {
      toggle.addEventListener('click', () => {
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        const toggleText = toggle.querySelector('.c-index__toggle-text');

        // Toggle state
        toggle.setAttribute('aria-expanded', String(!isExpanded));
        index.classList.toggle('is-collapsed', isExpanded);

        // Update text
        if (toggleText) {
          toggleText.textContent = isExpanded ? '開く' : '閉じる';
        }
      });
    }
  });
}

/**
 * Initialize FAQ accordion functionality
 * Toggles individual FAQ item visibility
 */
export function initFaqAccordion() {
  const faqItems = document.querySelectorAll('.js-faq-item');

  faqItems.forEach((item) => {
    const trigger = item.querySelector('.js-faq-trigger');

    if (trigger) {
      // Toggle helper function to avoid duplication
      const toggleItem = () => {
        const isOpen = item.classList.contains('is-open');
        item.classList.toggle('is-open', !isOpen);
        trigger.setAttribute('aria-expanded', String(!isOpen));
      };

      // Click handler
      trigger.addEventListener('click', toggleItem);

      // Keyboard handler (Enter/Space)
      trigger.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggleItem();
        }
      });
    }
  });
}

/**
 * Initialize all accordions
 * Convenience function to initialize both Index TOC and FAQ accordions
 */
export function initTocFAQ() {
  initIndexToggle();
  initFaqAccordion();
}
